import { DialogComponent } from '@theme/dialog';

const WORKER_URL = 'https://pbw-reviews-worker.pbw-costaluis.workers.dev';

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str ?? '';
  return div.innerHTML;
}

function starsHtml(rating) {
  const filled = Math.round(rating);
  let out = '';
  for (let i = 1; i <= 5; i++) {
    out += i <= filled ? '★' : '☆';
  }
  return out;
}

class ReviewsDialog extends DialogComponent {
  async loadReviews(productId) {
    const content = this.querySelector('#reviews-dialog-content');
    if (!content) return;

    content.innerHTML = '<p class="reviews-dialog__status">Loading reviews…</p>';
    this.showDialog();

    try {
      const res = await fetch(`${WORKER_URL}/apps/reviews/product/${encodeURIComponent(productId)}`);
      const data = await res.json();
      const reviews = data.reviews || [];

      if (!reviews.length) {
        content.innerHTML = '<p class="reviews-dialog__status">No reviews yet for this wine.</p>';
        return;
      }

      content.innerHTML = reviews
        .map((r) => {
          const date = r.created_at ? new Date(r.created_at.replace(' ', 'T') + 'Z').toLocaleDateString('en-GB') : '';
          return `
            <div class="reviews-dialog__review">
              <div class="reviews-dialog__stars">${starsHtml(r.rating)}</div>
              ${r.title ? `<p class="reviews-dialog__title">${escapeHtml(r.title)}</p>` : ''}
              ${r.body ? `<p class="reviews-dialog__body">${escapeHtml(r.body)}</p>` : ''}
              <p class="reviews-dialog__meta">${escapeHtml(r.customer_name || 'Anonymous')}${date ? ' - ' + date : ''}</p>
              ${r.reply ? `<details class="reviews-dialog__reply pbw-review-reply"><summary class="reviews-dialog__reply-heading">Reply from Portugal Best Wines</summary><p class="reviews-dialog__reply-body">${escapeHtml(r.reply)}</p></details>` : ''}
            </div>
          `;
        })
        .join('');
    } catch (error) {
      content.innerHTML = '<p class="reviews-dialog__status">Could not load reviews right now.</p>';
    }
  }
}

if (!customElements.get('reviews-dialog')) customElements.define('reviews-dialog', ReviewsDialog);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.product-information .rating-wrapper');
  if (!trigger) return;

  const productId = window.__pbwReviewsProductId;
  if (!productId) return;

  const dialog = document.getElementById('reviews-dialog');
  if (dialog instanceof ReviewsDialog) {
    dialog.loadReviews(productId);
  }
});
